import React from 'react';
import { motion } from 'framer-motion';
import { GoldButton } from './ui/GoldButton';
import { Star, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center py-20 px-4 overflow-hidden bg-dark-900" data-id="element-51">
      {/* Background Effects */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-52">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-gold-DEFAULT/10 rounded-full blur-[100px]" data-id="element-53" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-colombia-blue/10 rounded-full blur-[100px]" data-id="element-54" />
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-55">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="text-center lg:text-left" data-id="element-56">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-dark-800 border border-gold-dark/30 mb-6" data-id="element-57">
            <span className="flex h-3 w-3 relative" data-id="element-58">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-colombia-yellow opacity-75" data-id="element-59"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-colombia-yellow" data-id="element-60"></span>
            </span>
            <span className="text-sm font-medium text-gold-light tracking-wide uppercase" data-id="element-61">
              Calidad Colombiana Original
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6 text-white" data-id="element-62">
            La Faja Colombiana{' '}
            <span className="text-gold-gradient" data-id="element-63">Original</span> para Mujeres
            Plus Size de EE.UU.
          </h1>

          <h2 className="text-xl md:text-2xl text-gray-300 font-light mb-8 leading-relaxed" data-id="element-64">
            Ebook + Faja Colombiana Original + Asesoría Personalizada:{' '}
            <br className="hidden md:block" data-id="element-65" />
            <span className="text-white font-medium" data-id="element-66">
              El Paquete Exclusivo para Tallas 2XL a 5XL
            </span>
          </h2>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-10" data-id="element-67">
            <GoldButton className="shadow-gold-DEFAULT/20" scrollTo="#cta" data-id="element-68">
              ¡Quiero Mi Faja Colombiana!
            </GoldButton>
          </div>

          <div className="flex items-center justify-center lg:justify-start gap-6 text-sm text-gray-400" data-id="element-69">
            <div className="flex items-center gap-2" data-id="element-70">
              <Star className="w-4 h-4 text-gold-DEFAULT fill-gold-DEFAULT" data-id="element-71" />
              <span data-id="element-72">Calidad Premium</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-73">
              <ShieldCheck className="w-4 h-4 text-gold-DEFAULT" data-id="element-74" />
              <span data-id="element-75">Garantía de Satisfacción</span>
            </div>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-76">
          <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl shadow-gold-DEFAULT/10 border border-gold-dark/20" data-id="element-77">
            <img src="https://cdn.magicpatterns.com/uploads/gxczg8vL4gJvvbDJQfYR81/COLOMBIANA_(1).png" alt="Faja Colombiana Premium en Tablet" className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700" data-id="element-78" />

            {/* Floating Badge */}
            <div className="absolute bottom-6 right-6 bg-dark-900/90 backdrop-blur-md border border-gold-DEFAULT p-4 rounded-lg shadow-xl max-w-[180px]" data-id="element-79">
              <div className="flex gap-1 mb-1" data-id="element-80">
                <div className="h-1 w-full bg-colombia-yellow rounded-full" data-id="element-81"></div>
                <div className="h-1 w-full bg-colombia-blue rounded-full" data-id="element-82"></div>
                <div className="h-1 w-full bg-colombia-red rounded-full" data-id="element-83"></div>
              </div>
              <p className="text-xs text-center text-white font-serif" data-id="element-84">
                Diseño Auténtico Colombiano
              </p>
            </div>
          </div>

          {/* Decorative Elements behind image */}
          <div className="absolute -top-10 -right-10 w-32 h-32 bg-gold-DEFAULT/20 rounded-full blur-3xl z-0" data-id="element-85"></div>
          <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-colombia-blue/20 rounded-full blur-3xl z-0" data-id="element-86"></div>
        </motion.div>
      </div>
    </section>;
}